import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import es from "../Languages/es.json";
import pt from "../Languages/pt.json";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { languages } from "../config/strings";

// Inicializar i18n una sola vez al cargar el módulo
i18n.use(initReactI18next).init({
  resources: {
    es: {
      translation: es,
    },
    pt: {
      translation: pt,
    },
  },
  lng: languages.es, // Idioma por defecto
  fallbackLng: languages.es,

  interpolation: {
    escapeValue: false,
  },
});

// Hook personalizado para cambiar idioma cuando cambie en Redux
export const useGetLanguage = () => {
  const { language } = useSelector((state) => state.local);

  useEffect(() => {
    if (language && i18n.language !== language) {
      i18n.changeLanguage(language);
    }
  }, [language]);
};

// Función legacy para compatibilidad (ya no hace nada, la inicialización ya ocurrió)
export const GetLanguage = () => {
  // Esta función se mantiene por compatibilidad pero ya no es necesaria
  // La inicialización ahora ocurre al cargar el módulo
};
